export default __webpack_public_path__ + "static/media/CHRONIC-OBSTRUCTIVE-PULMONARY-DISEASE.96060389.png";